const topicFrame = document.querySelector('#questions .topic');
const questionFrame = document.querySelector('#questions .question');
const questionNumberFrame = document.querySelector('header .progress span');
const answersFrames = document.querySelectorAll('#questions .answers .answer');
const nextQuestionButton = document.querySelector('#questions button');

let currentQuestionIndex = -1;
export let lastQuestion = false;

export function nextQuestion() {
    currentQuestionIndex++;
    const currentQuestion = questions[currentQuestionIndex];
    topicFrame.textContent = DOMPurify.sanitize(currentQuestion.topic);
    questionFrame.innerHTML = DOMPurify.sanitize(currentQuestion.question);

    let index = 0
    for (const [key, value] of Object.entries(currentQuestion.answers)) {
        let element = answersFrames[index];
        element.querySelector('.label').textContent = value;
        if (key === currentQuestion.correct_answer) {
            element.dataset.correct = '1';
        } else {
            element.dataset.correct = '0';
        }
        index++;
    }

    if (questions.length === currentQuestionIndex + 1) {
        nextQuestionButton.innerText = 'Befejezés';
        lastQuestion = true;
    }

    questionNumberFrame.textContent = currentQuestionIndex + 1;
}